import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import './plugins'
import store from './store'
import { sync } from 'vuex-router-sync'
import VeeValidate from 'vee-validate'
Vue.config.productionTip = false

// Only for development
process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0'; 

sync(store, router)
Vue.use(VeeValidate)
new Vue({
  router,
  vuetify,
  store,
  render: h => h(App),
}).$mount('#app')
